import { useBookingRecoilValue, useNewNavigate, usePensionNameValue } from "@/shared/client";
import { type Aside1DmaxInfoResponse } from "@/shared/server";
import { MEDIA } from "@/styles/common";
import { Box, Center, Flex, Text } from "@chakra-ui/react";
import { CustomButton, CustomSubTitle, CustomText, CustomTitle } from "./Aside1Banner.style";

export const Aside1Section = ({ aside1 }: { aside1: Aside1DmaxInfoResponse }) => {
    const { onNavigate } = useNewNavigate();
    const bookingURL = useBookingRecoilValue();
    const pensionName = usePensionNameValue();

    const { isMobile, isLaptop } = MEDIA();

    const { imgList, sector } = { ...aside1 };
    const onLink = (url: string) => {
        if (bookingURL.includes("http")) {
            window.open(url, "_blank");
        }
        if (!bookingURL.includes("http")) {
            window.open(`https://${url}`, "_blank");
        }
    };
    return (
        <Center as="section" maxW="none !important" background="#f8f8f8">
            <Flex
                maxW="1600px"
                w="100%"
                p={isMobile ? "0 16px" : "0 48px"}
                flexDir={isMobile ? "column" : "row"}
                justifyContent="space-between"
                gap={isMobile ? "16px" : "24px"}
            >
                <Flex maxW={isMobile ? "auto" : "560px"} w="100%" rowGap="136px" flexDir="column">
                    <Box>
                        <CustomSubTitle>{pensionName.kor}</CustomSubTitle>
                        <CustomTitle>
                            <Text>{sector.main.firstLine}</Text>
                            <Text>{sector.main.secondLine}</Text>
                        </CustomTitle>
                        <Box>
                            <CustomText>{sector.sub.firstLine}</CustomText>
                            <CustomText>{sector.sub.secondLine}</CustomText>
                        </Box>
                    </Box>
                    <Flex columnGap="16px">
                        <CustomButton
                            onClick={() => onLink(bookingURL)}
                            style={{ backgroundColor: "#749fa5", color: "#fff", border: "none" }}
                        >
                            예약하기
                        </CustomButton>
                        <CustomButton onClick={() => onNavigate({ path: "/guide" })}>이용안내</CustomButton>
                    </Flex>
                </Flex>
                <Flex maxW="920px" w="100%" position="relative">
                    <Box
                        w={isMobile ? "100%" : "568px"}
                        h={isMobile ? "296px" : "736px"}
                        background={imgList[0] ? `url(${imgList[0].img_URL}) no-repeat center/cover` : "gray.100"}
                    ></Box>
                    <Box
                        display={isLaptop ? "none" : "block"}
                        w="588px"
                        h="400px"
                        position="absolute"
                        top="50%"
                        bottom="auto"
                        transform="translateY(-50%)"
                        right="0"
                        background={imgList[1] ? `url(${imgList[1].img_URL}) no-repeat center/cover` : "gray.100"}
                    ></Box>
                </Flex>
            </Flex>
        </Center>
    );
};
